let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g1EA5")).then(() => parcelRequire('chhAm'));